<ng-container *ngIf="funders?.length">
    <div class="funded-by">Funded by</div>
    <div class="row-auto g-0">
        <div class="col-12" *ngFor="let item of funders">
            <app-logo
                [logoUrl]="item.logoColor"
                [name]="item.name"
                [role]="item.getRoles()"
            ></app-logo>
        </div>
    </div>
</ng-container>
<div *ngIf="credits" class="credits" [innerHTML]="credits"></div>
